import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import ResetPassword from './ResetPassword';
import * as actions from '../actions';
import * as selectors from '../selectors';

/**
 * Second part of the forgotten password process
 * User has been sent a link which allows them to access this form and provide a new password
 * @extends Component
 */
export class ResetPasswordContainer extends Component {
  handleSubmit = values => {
    const { params } = this.props.match;
    this.props.resetPassword(
      params.userId,
      params.code,
      values.get('password'),
      this.props.history
    );
  };

  render() {
    const { ui } = this.props;
    return (
      <ResetPassword
        onSubmit={this.handleSubmit}
        isLoading={ui.get('isLoading')}
        isError={ui.get('isError')}
        errorMessage={ui.get('errorMessage')}
      />
    );
  }
}

const mapStateToProps = createStructuredSelector({
  ui: selectors.getUI
});

export default connect(mapStateToProps, actions)(ResetPasswordContainer);



// WEBPACK FOOTER //
// ./src/modules/auth/components/ResetPasswordContainer.js